export default __webpack_public_path__ + "static/media/beach4.c4fed12a.jpg";